import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { getFirestore, collection, query, where, getDocs, doc, getDoc, updateDoc } from "firebase/firestore";
import { Table, Typography, Space, Button, InputNumber, Select, Input, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import { QRCodeCanvas } from 'qrcode.react';
import { DeleteOutlined, PlusOutlined, TagOutlined, InfoCircleOutlined, EditOutlined, UserAddOutlined } from '@ant-design/icons';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { buttonStyles } from '../../theme/theme';
import { primaryShades } from '../../theme/theme';
import {
    isVariantClickable,
    canModifyCoefficients,
    canModifyTagsBadges,
    canViewNotes,
} from '../services/Utils';
import { showSuccessNotification, showWarningNotification, showErrorNotification } from '../../utils/notifications';
import NoteViewer from '../modal/NoteViewerModal';
import EditProduct from '../modal/EditProductsModal';
import VariantsAssignedToModal from '../modal/VariantsAssignedToModal';
import AddNewTag from '../modal/tagsBadgesLine/AddNewTag';
import CreateNewTag from '../modal/tagsBadgesLine/CreateNewTag';
import AddNewBadge from '../modal/tagsBadgesLine/AddNewBadge';
import CreateNewBadge from '../modal/tagsBadgesLine/CreateNewBadge';
import AddNewLine from '../modal/tagsBadgesLine/AddNewLine';
import { secureGetItem } from '../../data/utils';
import HeaderComponent from '../../components/Components/Headers/HeaderComponent';
import CustomTooltip from '../../components/Components/Modals/CustomTooltip';
import { IconButton } from '../../components/Components/Buttons/Buttons';
import ButtonState from '../../components/Components/Buttons/ButtonState';
import MediumModal from '../../components/Components/Modals/MediumModal';
import SmallModal from '../../components/Components/Modals/SmallModal';
import HoverImageZoom from '../../components/Components/Images/HoverImageZoom';

function Variants() {
    const { brandId, productId } = useParams(); // Ottiene l'ID del brand e del prodotto dai parametri dell'URL
    const [variants, setVariants] = useState([]); // Stato per memorizzare le varianti
    const [loading, setLoading] = useState(true);
    const [categories, setCategories] = useState([]); // Stato per memorizzare le categorie
    const [productImage, setProductImage] = useState(""); // Stato per memorizzare l'URL dell'immagine del prodottoƒ
    const [positioningCoefficients, setPositioningCoefficients] = useState({
        glassesInclinationCoeff: "",
        glassesInclinationCoeffIos: "",
        glassesYCoeff: "",
        glassesYCoeffAndroid: "",
        glassesZCoeff: "",
        glassesZCoeffAndroid: ""
    });
    const [urlShadow, setUrlShadow] = useState(""); // Stato per memorizzare il link urlShadow
    const [productData, setProductData] = useState({}); // Stato per memorizzare i dati del prodotto
    const db = getFirestore(); // Inizializza Firestore
    const [isAddModalVisible, setIsAddModalVisible] = useState(false);
    const [selectedAddTagId, setSelectedAddTagId] = useState('');
    const [availableGroups, setAvailableGroups] = useState([]);
    const [availableTagsForGroup, setAvailableTagsForGroup] = useState([]);
    const [isCreateTagModalVisible, setIsCreateTagModalVisible] = useState(false);
    const [isAddBadgeModalVisible, setIsAddBadgeModalVisible] = useState(false);
    const [isCreateBadgeModalVisible, setIsCreateBadgeModalVisible] = useState(false);
    const [isAssignedModalVisible, setIsAssignedModalVisible] = useState(false);
    const [processedImages, setProcessedImages] = useState({});
    const [isAddLineModalVisible, setIsAddLineModalVisible] = useState(false);
    const [isPositioningModalVisible, setIsPositioningModalVisible] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [isProductModalVisible, setIsProductModalVisible] = useState(false);
    const [isEditNameModalVisible, setIsEditNameModalVisible] = useState(false);
    const [newProductName, setNewProductName] = useState('');
    const [userProfiles, setUserProfiles] = useState({});
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const { Title } = Typography;
    const { Option } = Select;

    // Componente QR Code con Hover Effect
    const QRCodeWithHover = ({ value, id }) => {
        const [isHovered, setIsHovered] = useState(false);

        const handleDownloadQrCode = () => {
            const canvas = document.getElementById(`qr-code-${id}`);
            if (canvas) {
                const url = canvas.toDataURL('image/png');
                const link = document.createElement('a');
                link.href = url;
                link.download = `qrcode-${id || 'product'}.png`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        };

        return (
            <div
                style={{
                    position: 'relative',
                    width: 150,
                    height: 150,
                    cursor: 'pointer',
                    borderRadius: "8px",
                    overflow: "hidden"
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={handleDownloadQrCode}
            >
                <QRCodeCanvas
                    id={`qr-code-${id}`}
                    value={value}
                    size={150}
                    bgColor={"#ffffff"}
                    fgColor={"#000000"}
                    marginSize={4}
                    level={"H"}
                    includeMargin={false}
                    imageSettings={{
                        excavate: true,
                        margin: 0
                    }}
                    style={{ borderRadius: "8px" }}
                />

                {/* Background overlay con opacità */}
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: primaryShades.primary300,
                        borderRadius: '8px',
                        opacity: isHovered ? 0.90 : 0,
                        transition: 'opacity 0.3s ease-in-out',
                        pointerEvents: isHovered ? 'auto' : 'none'
                    }}
                />

                {/* Icona di download (sempre a opacità piena) */}
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        opacity: isHovered ? 1 : 0,
                        transition: 'opacity 0.3s ease-in-out',
                        pointerEvents: 'none' // L'intero contenitore è già cliccabile
                    }}
                >
                    <FileDownloadIcon
                        style={{
                            color: 'white',
                            fontSize: '3.5rem',
                            transform: isHovered ? 'scale(1)' : 'scale(0.8)',
                            transition: 'transform 0.3s ease-in-out'
                        }}
                    />
                </div>
            </div>
        );
    };

    const role = secureGetItem("role"); // Recupera il ruolo dell'utente

    // Hook per gestire il resize della finestra
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Recupera i profili utente dal database
    useEffect(() => {
        const fetchUserProfiles = async () => {
            try {
                const profilesRef = collection(db, "Profiles");
                const profilesSnapshot = await getDocs(profilesRef);
                const profilesData = {};

                profilesSnapshot.forEach((doc) => {
                    const data = doc.data();

                    // Gestisci sia _email che email (se presente)
                    const email = data._email || data.email;
                    if (email) {
                        profilesData[email] = {
                            firstName: data.firstName || '',
                            lastName: data.lastName || ''
                        };
                    }
                });

                setUserProfiles(profilesData);
            } catch (error) {
                console.error("Error fetching user profiles:", error);
            }
        };

        fetchUserProfiles();
    }, []);

    // Immagine placeholder per errori CORS e 404 - usa la stessa logica di ARSCatalog e Products
    const createPlaceholderImage = (width = 400, height = 400) => {
        return 'data:image/svg+xml;base64,' + btoa(`
<svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg">
  <rect width="${width}" height="${height}" fill="#f5f5f5" stroke="#d9d9d9" stroke-width="2"/>
  <g transform="translate(${width / 2}, ${height / 2})">
    <text x="0" y="-10" font-family="Arial, sans-serif" font-size="${Math.min(width, height) * 0.08}" fill="#999" text-anchor="middle">No Image</text>
    <text x="0" y="15" font-family="Arial, sans-serif" font-size="${Math.min(width, height) * 0.06}" fill="#999" text-anchor="middle">Available</text>
  </g>
</svg>
`);
    };

    const DEFAULT_PLACEHOLDER = createPlaceholderImage();

    // Funzione per rimuovere lo sfondo bianco dalle immagini con gestione fallback
    const removeWhiteBackground = (imgUrl, id) => {
        if (!imgUrl) return null;
        if (processedImages[id]) return processedImages[id];

        try {
            // Crea un elemento immagine per caricare l'URL
            const img = new Image();
            img.crossOrigin = "Anonymous";

            img.onload = () => {
                try {
                    // Crea un canvas per elaborare l'immagine
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');

                    // Imposta le dimensioni del canvas
                    canvas.width = img.width;
                    canvas.height = img.height;

                    // Disegna l'immagine nel canvas
                    ctx.drawImage(img, 0, 0);

                    // Ottieni i dati dei pixel dell'immagine
                    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                    const data = imageData.data;

                    // Rimuovi lo sfondo bianco rendendo trasparenti i pixel bianchi
                    for (let i = 0; i < data.length; i += 4) {
                        const r = data[i];
                        const g = data[i + 1];
                        const b = data[i + 2];

                        // Se il pixel è vicino al bianco, rendilo trasparente
                        if (r > 240 && g > 240 && b > 240) {
                            data[i + 3] = 0; // Imposta il canale alpha a 0 (trasparente)
                        }
                    }

                    // Aggiorna l'immagine nel canvas
                    ctx.putImageData(imageData, 0, 0);

                    // Converti il canvas in un URL di dati
                    const processedImageUrl = canvas.toDataURL('image/png');

                    // Aggiorna lo stato delle immagini elaborate
                    setProcessedImages(prev => ({
                        ...prev,
                        [id]: processedImageUrl
                    }));
                } catch (canvasError) {
                    console.warn(`Canvas processing failed for image ${imgUrl}:`, canvasError.message);
                    // In caso di errore del canvas, usa l'immagine originale
                    setProcessedImages(prev => ({
                        ...prev,
                        [id]: imgUrl
                    }));
                }
            };

            img.onerror = (error) => {
                console.warn(`Failed to load image ${imgUrl}:`, error);
                // In caso di errore di caricamento, usa il placeholder
                setProcessedImages(prev => ({
                    ...prev,
                    [id]: DEFAULT_PLACEHOLDER
                }));
            };

            img.src = imgUrl;

            // Restituisci l'URL originale immediatamente, l'elaborazione avverrà in background
            return imgUrl;
        } catch (error) {
            console.warn(`Error processing image ${imgUrl}:`, error.message);
            return imgUrl; // Restituisci l'URL originale in caso di errore
        }
    };

    // Mappa di traduzione degli status dall'italiano all'inglese
    const statusMapping = {
        'Rev. Modellista': 'Modelist Rev.',
        'Rev. Cliente': 'Client Rev.',
        'Rev. Spaarkly': 'Spaarkly Rev.',
        'Incompleto': 'Incomplete',
        'In Pubblicazione': 'In Publication',
    };

    // Navigazione tra le pagine
    const navigate = useNavigate();

    // Funzione per gestire il click sulla variante
    const handleVariantClick = (variantId, variantStatus) => {
        if (isVariantClickable(role, variantStatus)) {
            navigate(`/framevalidation/${brandId}/${productId}/${variantId}`);
        } else {
            showWarningNotification("Warning", "You do not have the permissions to access this variant.");
        }
    };

    // Effect che viene eseguito quando le varianti cambiano
    useEffect(() => {
        const fetchVariants = async () => {
            setLoading(true);
            try {
                // Crea una query per ottenere le varianti associate al prodotto specifico
                const q = query(
                    collection(db, "Variants"),
                    where("productRef", "==", productId) // Filtra per ID del prodotto
                );

                // Esegue la query e mappa i risultati in un array di varianti
                const querySnapshot = await getDocs(q);
                const variantsList = querySnapshot.docs
                    .map(doc => ({ id: doc.id, ...doc.data() }))
                    .filter(variant => variant.status !== "Pubblicato")
                    .map(variant => ({
                        ...variant,
                        status: statusMapping[variant.status] || variant.status // Applica la mappatura dello stato
                    }))
                    .sort((a, b) => {
                        const order = ['In Publication', 'Client Rev.', 'Spaarkly Rev.', 'Modelist Rev.', 'Incomplete'];
                        return order.indexOf(a.status) - order.indexOf(b.status);
                    });

                setVariants(variantsList); // Aggiorna lo stato con le varianti recuperate
            } catch (error) {
                console.error("Error fetching variants:", error);
                showErrorNotification("Error", "Error fetching variants"); // Mostra un messaggio di errore
            } finally {
                setLoading(false);
            }
        };

        fetchVariants(); // Chiama la funzione per recuperare le varianti
    }, [productId, db]); // Recupera quando productId o db cambiano

    // Modifica l'effect che carica i dati dei coefficienti
    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const productRef = doc(db, "Products", productId);
                const productSnapshot = await getDoc(productRef);

                if (productSnapshot.exists()) {
                    const data = productSnapshot.data();
                    setProductData(data);
                    setProductImage(data.urlImage || "");
                    setUrlShadow(data.urlShadow || "");

                    // Carica i coefficienti solo se l'utente ha i permessi
                    if (canModifyCoefficients(role)) {
                        setPositioningCoefficients({
                            glassesInclinationCoeff: data.glassesInclinationCoeff || "",
                            glassesInclinationCoeffIos: data.glassesInclinationCoeffIos || "",
                            glassesYCoeff: data.glassesYCoeff || "",
                            glassesYCoeffAndroid: data.glassesYCoeffAndroid || "",
                            glassesZCoeff: data.glassesZCoeff || "",
                            glassesZCoeffAndroid: data.glassesZCoeffAndroid || ""
                        });
                    } else {
                        // Se l'utente non ha i permessi, imposta valori vuoti
                        setPositioningCoefficients({
                            glassesInclinationCoeff: "",
                            glassesInclinationCoeffIos: "",
                            glassesYCoeff: "",
                            glassesYCoeffAndroid: "",
                            glassesZCoeff: "",
                            glassesZCoeffAndroid: ""
                        });
                    }

                    // Nella tabella "Taxonomies & Badges" vengono mostrati sia i tag che le linee.
                    // Combina list_tags e list_line_tags
                    const categoryRefs = [...(data.list_tags || []), ...(data.list_line_tags || [])];

                    if (categoryRefs.length === 0) {
                        setCategories([]);
                        return;
                    }

                    const categoryPromises = categoryRefs.map(async (categoryRef) => {
                        let categoryId;

                        // Gestisci diversi possibili formati del riferimento
                        if (typeof categoryRef === 'string') {
                            // Se è una stringa nel formato '/Tags/ID'
                            categoryId = categoryRef.includes('/') ? categoryRef.split('/').pop() : categoryRef;
                        } else if (categoryRef && typeof categoryRef === 'object') {
                            // Se è un oggetto riferimento di Firebase
                            if (categoryRef.path) {
                                categoryId = categoryRef.path.split('/').pop();
                            } else if (categoryRef.id) {
                                categoryId = categoryRef.id;
                            }
                        } else {
                            return null;
                        }

                        if (!categoryId) return null;

                        const tagClassRef = doc(db, "Tags", categoryId);
                        const tagSnapshot = await getDoc(tagClassRef);

                        if (tagSnapshot.exists()) {
                            const tagData = tagSnapshot.data();
                            return {
                                id: categoryId,
                                name: tagData.name,
                                group: tagData.group,
                                type: tagData.type
                            };
                        }
                        return null;
                    });
                    const resolvedCategories = (await Promise.all(categoryPromises)).filter(Boolean);
                    setCategories(resolvedCategories);
                }
            } catch (error) {
                console.error("Error fetching categories:", error);
                showErrorNotification("Error", "Error fetching categories");
            }
        };

        fetchCategories();
    }, [productId, db, role]); // Add role to dependencies

    // Modifica la funzione per gestire il cambio dei coefficienti
    const handleCoefficientChange = async (platform, axis, value) => {
        if (!canModifyCoefficients(role)) {
            showWarningNotification("Warning", "You do not have the permissions to modify coefficients.");
            return;
        }
        try {
            const fieldMap = {
                ios: {
                    x: 'glassesInclinationCoeffIos',
                    y: 'glassesYCoeff',
                    z: 'glassesZCoeff'
                },
                android: {
                    x: 'glassesInclinationCoeff',
                    y: 'glassesYCoeffAndroid',
                    z: 'glassesZCoeffAndroid'
                }
            };

            const fieldName = fieldMap[platform][axis];
            const productRef = doc(db, "Products", productId);
            await updateDoc(productRef, { [fieldName]: value });

            setPositioningCoefficients(prevCoefficients => ({
                ...prevCoefficients,
                [fieldName]: value
            }));

            showSuccessNotification("Save successful", `Coefficient ${axis.toUpperCase()} updated successfully for ${platform}`);
        } catch (error) {
            console.error(`Error updating coefficient ${axis.toUpperCase()} for ${platform}:`, error);
            showErrorNotification("Error", `Error updating coefficient ${axis.toUpperCase()} for ${platform}`);
        }
    };

    // Funzione per gestire l'apertura della modale per aggiungere un nuovo tag
    const handleOpenAddTagModal = () => {
        setIsAddModalVisible(true);
    };

    // Funzione per gestire la chiusura della modale per aggiungere un nuovo tag
    const handleAddTagModalClose = async (updated) => {
        setIsAddModalVisible(false);

        if (updated) {
            await refreshCategoriesData();
        }
    };

    // Funzione per aggiornare le categorie dal database
    const refreshCategoriesData = async () => {
        try {
            const productRef = doc(db, "Products", productId);
            const productSnapshot = await getDoc(productRef);

            if (productSnapshot.exists()) {
                const data = productSnapshot.data();

                // Combina list_tags e list_line_tags
                const categoryRefs = [...(data.list_tags || []), ...(data.list_line_tags || [])];

                if (categoryRefs.length === 0) {
                    setCategories([]);
                    return;
                }

                const categoryPromises = categoryRefs.map(async (categoryRef) => {
                    let categoryId;

                    // Gestisci diversi possibili formati del riferimento
                    if (typeof categoryRef === 'string') {
                        // Se è una stringa nel formato '/Tags/ID'
                        categoryId = categoryRef.includes('/') ? categoryRef.split('/').pop() : categoryRef;
                    } else if (categoryRef && typeof categoryRef === 'object') {
                        // Se è un oggetto riferimento di Firebase
                        if (categoryRef.path) {
                            categoryId = categoryRef.path.split('/').pop();
                        } else if (categoryRef.id) {
                            categoryId = categoryRef.id;
                        }
                    } else {
                        return null;
                    }

                    if (!categoryId) return null;

                    const tagClassRef = doc(db, "Tags", categoryId);
                    const tagSnapshot = await getDoc(tagClassRef);

                    if (tagSnapshot.exists()) {
                        const tagData = tagSnapshot.data();
                        return {
                            id: categoryId,
                            name: tagData.name,
                            group: tagData.group,
                            type: tagData.type
                        };
                    }
                    return null;
                });

                const resolvedCategories = (await Promise.all(categoryPromises)).filter(Boolean);
                setCategories(resolvedCategories);
            }
        } catch (error) {
            console.error("Error fetching updated categories:", error);
            showErrorNotification("Error", "Error fetching updated categories");
        }
    };

    // Funzione per gestire la rimozione di una categoria
    const handleDeleteCategory = async (categoryId) => {
        try {
            // Get the latest product data directly from the database
            const productRef = doc(db, "Products", productId);
            const productSnapshot = await getDoc(productRef);

            if (!productSnapshot.exists()) {
                showErrorNotification("Error", "Product not found");
                return;
            }

            // Use the latest product data
            const currentProductData = productSnapshot.data();
            const currentTags = currentProductData.list_tags || [];
            const currentLineTags = currentProductData.list_line_tags || [];

            // Aggiorna le categorie rimuovendo il riferimento
            const updatedTags = currentTags.filter(catRef => {
                let id;
                if (typeof catRef === 'string') {
                    id = catRef.includes('/') ? catRef.split('/').pop() : catRef;
                } else if (catRef && typeof catRef === 'object') {
                    if (catRef.path) {
                        id = catRef.path.split('/').pop();
                    } else if (catRef.id) {
                        id = catRef.id;
                    }
                }
                return id !== categoryId;
            });

            const updatedLineTags = currentLineTags.filter(catRef => {
                let id;
                if (typeof catRef === 'string') {
                    id = catRef.includes('/') ? catRef.split('/').pop() : catRef;
                } else if (catRef && typeof catRef === 'object') {
                    if (catRef.path) {
                        id = catRef.path.split('/').pop();
                    } else if (catRef.id) {
                        id = catRef.id;
                    }
                }
                return id !== categoryId;
            });

            await updateDoc(productRef, { list_tags: updatedTags, list_line_tags: updatedLineTags });

            showSuccessNotification("Save successful", "Category removed successfully");

            // Aggiorna lo stato locale delle categorie e i dati del prodotto
            setCategories(prevCategories => prevCategories.filter(cat => cat.id !== categoryId));

            // Aggiorna anche i dati del prodotto nel local state
            setProductData(prevData => ({
                ...prevData,
                list_tags: updatedTags,
                list_line_tags: updatedLineTags
            }));
        } catch (error) {
            console.error("Error removing category:", error);
            showErrorNotification("Error", "Error removing category");
        }
    };

    // Funzione per caricare i gruppi di tag
    useEffect(() => {
        if (isAddModalVisible) {
            const fetchGroups = async () => {
                try {
                    const querySnapshot = await getDocs(collection(db, "Tags"));
                    const groups = Array.from(new Set(querySnapshot.docs.map(doc => doc.data().group)));
                    setAvailableGroups(groups);
                } catch (error) {
                    console.error("Error fetching groups:", error);
                    showErrorNotification("Error", "Error fetching groups");
                }
            };
            fetchGroups();
        }
    }, [isAddModalVisible, db]);

    // Funzione per caricare i tag per il gruppo selezionato
    useEffect(() => {
        const fetchTagsForGroup = async () => {
            if (!selectedAddTagId) return;

            try {
                const q = query(
                    collection(db, "Tags"),
                    where("group", "==", selectedAddTagId)
                );

                const querySnapshot = await getDocs(q);
                const tags = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    name: doc.data().name
                }));

                setAvailableTagsForGroup(tags);
            } catch (error) {
                console.error("Error fetching tags:", error);
                showErrorNotification("Error", "Error fetching tags");
            }
        };

        fetchTagsForGroup();
    }, [selectedAddTagId, db]);

    // Funzione per gestire l'apertura della modale per aggiungere un badge esistente
    const handleOpenAddBadgeModal = () => {
        setIsAddBadgeModalVisible(true);
    };

    // Funzione per gestire la chiusura della modale per aggiungere un badge esistente
    const handleAddBadgeModalClose = async (updated) => {
        setIsAddBadgeModalVisible(false);

        if (updated) {
            await refreshCategoriesData();
        }
    };

    // Funzione per gestire l'apertura della modale per creare un nuovo tag
    const handleOpenCreateTagModal = () => {
        setIsCreateTagModalVisible(true);
    };

    // Funzione per gestire la chiusura della modale per creare un nuovo tag
    const handleCreateTagModalClose = async (updated) => {
        setIsCreateTagModalVisible(false);

        if (updated) {
            await refreshCategoriesData();
        }
    };

    // Controlla se tutte le varianti sono assegnate a un utente
    const allVariantsAssigned = variants.every(variant => variant.assignedTo);

    // Configurazione per l'upload dell'icona del badge
    const uploadProps = {
        beforeUpload: (file) => {
            const isImage = file.type.startsWith('image/');
            if (!isImage) {
                showErrorNotification("Error", "You can only upload image files!");
                return false;
            }

            // Non più necessario convertire l'immagine in base64 qui
            // Questa funzionalità è stata spostata nel componente CreateNewBadge
            return false; // Previene l'upload automatico
        },
        maxCount: 1,
    };

    // Funzione per gestire l'apertura della modale per creare un nuovo badge
    const handleOpenCreateBadgeModal = () => {
        setIsCreateBadgeModalVisible(true);
    };

    // Funzione per gestire la chiusura della modale per creare un nuovo badge
    const handleCreateBadgeModalClose = async (updated) => {
        setIsCreateBadgeModalVisible(false);

        if (updated) {
            await refreshCategoriesData();
        }
    };

    // Funzione per gestire l'apertura della modale per aggiungere una nuova linea
    const handleOpenAddLineModal = () => {
        setIsAddLineModalVisible(true);
    };

    // Funzione per gestire la chiusura della modale per aggiungere una nuova linea
    const handleAddLineModalClose = async (updated) => {
        setIsAddLineModalVisible(false);

        if (updated) {
            await refreshCategoriesData();
        }
    };

    // Definizione delle colonne per la tabella delle varianti
    const columns = [
        {
            title: (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span>Image</span>
                    <CustomTooltip title="Variant image">
                        <InfoCircleOutlined style={{ marginLeft: '8px', cursor: 'pointer' }} />
                    </CustomTooltip>
                </div>
            ),
            dataIndex: 'poster',
            key: 'poster',
            width: '7%',
            render: (text, record) => {
                const imgSrc = processedImages[record.id] || text;

                if (!processedImages[record.id] && text) {
                    removeWhiteBackground(text, record.id);
                }

                return (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                        {imgSrc ? (
                            <HoverImageZoom
                                src={imgSrc}
                                alt="Variant"
                                style={{ width: 'clamp(2.5rem, 2rem + 2vw, 3.125rem)', objectFit: 'contain' }}
                                onClick={() => handleVariantClick(record.id, record.status)}
                            />
                        ) : (
                            <div
                                style={{
                                    width: 'clamp(2.5rem, 2rem + 2vw, 3.125rem)',
                                    height: 'clamp(2.5rem, 2rem + 2vw, 3.125rem)',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    color: '#999',
                                    fontSize: '0.75rem',
                                    cursor: 'pointer'
                                }}
                                onClick={() => handleVariantClick(record.id, record.status)}
                            >
                                No Image
                            </div>
                        )}
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                    <span>Glasses Name</span>
                    <CustomTooltip title="Name of the glasses">
                        <InfoCircleOutlined style={{ marginLeft: '8px', cursor: 'pointer' }} />
                    </CustomTooltip>
                </div>
            ),
            dataIndex: 'glassesName',
            key: 'glassesName',
            render: (text, record) => (
                <span
                    onClick={() => handleVariantClick(record.id, record.status)}
                    style={{ cursor: 'pointer', color: 'black', textDecoration: 'underline' }}
                >
                    {text}
                </span>
            ),
            width: '15%',
        },
        {
            title: (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                    <span>SKU</span>
                    <CustomTooltip title="Stock Keeping Unit">
                        <InfoCircleOutlined style={{ marginLeft: '8px', cursor: 'pointer' }} />
                    </CustomTooltip>
                </div>
            ),
            dataIndex: 'skuModel',
            key: 'skuModel',
            width: '10%',
            align: 'left',
        },
        {
            title: (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                    <span>Frame Color</span>
                    <CustomTooltip title="Color of the frame">
                        <InfoCircleOutlined style={{ marginLeft: '8px', cursor: 'pointer' }} />
                    </CustomTooltip>
                </div>
            ),
            dataIndex: 'frameColor',
            key: 'frameColor',
            width: '10%',
            align: 'left',
        },
        {
            title: (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                    <span>Lenses Color</span>
                    <CustomTooltip title="Color of the lenses">
                        <InfoCircleOutlined style={{ marginLeft: '8px', cursor: 'pointer' }} />
                    </CustomTooltip>
                </div>
            ),
            dataIndex: 'lensesColor',
            key: 'lensesColor',
            width: '10%',
            render: (text) => text || 'TRANSPARENT',
            align: 'left',
        },
        {
            title: (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span>Batch</span>
                    <CustomTooltip title="Batch number">
                        <InfoCircleOutlined style={{ marginLeft: '8px', cursor: 'pointer' }} />
                    </CustomTooltip>
                </div>
            ),
            dataIndex: 'batch',
            key: 'batch',
            width: '6%',
            align: 'right',
        },
        {
            title: (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span>Size</span>
                    <CustomTooltip title="Size of the glasses">
                        <InfoCircleOutlined style={{ marginLeft: '8px', cursor: 'pointer' }} />
                    </CustomTooltip>
                </div>
            ),
            dataIndex: 'size',
            key: 'size',
            width: '6%',
            render: (size) => size.size,
            sorter: (a, b) => a.size.size - b.size.size,
            align: 'center',
        },
        {
            title: (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span>Assigned To</span>
                    <CustomTooltip title="Person assigned to">
                        <InfoCircleOutlined style={{ marginLeft: '8px', cursor: 'pointer' }} />
                    </CustomTooltip>
                </div>
            ),
            dataIndex: 'assignedTo',
            key: 'assignedTo',
            width: '10%',
            render: (email) => {
                if (!email) return <span style={{ color: '#888' }}>Not assigned</span>;

                // Verifica se l'email esiste esattamente come è
                const userProfile = userProfiles[email];
                if (userProfile && userProfile.firstName && userProfile.lastName) {
                    return `${userProfile.firstName} ${userProfile.lastName}`;
                }

                // Prova a cercare l'email in modo case-insensitive
                const lowerEmail = email.toLowerCase().trim();
                const matchingKey = Object.keys(userProfiles).find(key => key.toLowerCase().trim() === lowerEmail);
                if (matchingKey) {
                    const profile = userProfiles[matchingKey];
                    if (profile && profile.firstName && profile.lastName) {
                        return `${profile.firstName} ${profile.lastName}`;
                    }
                }

                return email; // Fallback to email if profile not found
            },
            align: 'right',
        },
        {
            title: (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span>Assignment Date</span>
                    <CustomTooltip title="Date of assignment">
                        <InfoCircleOutlined style={{ marginLeft: '8px', cursor: 'pointer' }} />
                    </CustomTooltip>
                </div>
            ),
            dataIndex: 'assignmentDate',
            key: 'assignmentDate',
            width: '10%',
            render: (text) => text || <span style={{ color: '#888' }}>Not assigned</span>,
            align: 'right',
        },
        {
            title: (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                    <span>Note</span>
                    <CustomTooltip title="Notes related to the variant">
                        <InfoCircleOutlined style={{ marginLeft: '8px', cursor: 'pointer' }} />
                    </CustomTooltip>
                </div>
            ),
            dataIndex: 'list_notes',
            key: 'note',
            width: '7%',
            render: (list_notes = [], record) => (
                canViewNotes(role, record.status) ? (
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <NoteViewer list_notes={list_notes} record={record} userProfiles={userProfiles} />
                    </div>
                ) : (
                    <div style={{ color: 'gray', textAlign: 'center' }}>{list_notes?.length || 0}</div>
                )
            ),
            align: 'center',
        },
        {
            title: (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                    <span>Status</span>
                    <CustomTooltip title="Current status of the variant">
                        <InfoCircleOutlined style={{ marginLeft: '8px', cursor: 'pointer' }} />
                    </CustomTooltip>
                </div>
            ),
            dataIndex: 'status',
            sorter: (a, b) => a.status.localeCompare(b.status),
            key: 'status',
            width: '30%',
            render: (text) => {
                // Map Italian status to English if needed
                const statusTranslations = {
                    "In Pubblicazione": "In Publication",
                    "Rev. Modellista": "Modelist Rev.",
                    "Rev. Cliente": "Client Rev.",
                    "Rev. Spaarkly": "Spaarkly Rev.",
                    "Incompleto": "Incomplete"
                };
                const translatedStatus = statusTranslations[text] || text;

                return (
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <ButtonState
                            state={translatedStatus}
                            text={text}
                            style={{
                                width: '100%',
                                maxWidth: '160px'
                            }}
                        />
                    </div>
                );
            },
            align: 'right',
        },
    ];

    // Visibilità del header
    const isAdminAccess = role === 'Admin' || role === 'Modellista' || role === 'ModellerSupervisor';
    // Visibilità dell'assegnatario - solo Admin e ModellerSupervisor
    const canAssignVariants = role === 'Admin' || role === 'ModellerSupervisor';

    // Funzione per gestire la modifica del nome del prodotto
    const handleEditProductName = async () => {
        try {
            const productRef = doc(db, "Products", productData.id);
            await updateDoc(productRef, { modelName: newProductName });

            // Aggiorna lo stato locale
            setProductData({
                ...productData,
                modelName: newProductName
            });

            setIsEditNameModalVisible(false);
            showSuccessNotification("Save successful", "Product name updated successfully");
        } catch (error) {
            console.error("Error updating product name:", error);
            showErrorNotification("Error", "Error updating product name");
        }
    };

    // Funzione per aprire la modale di modifica del nome del prodotto
    const openEditNameModal = () => {
        setNewProductName(productData.modelName);
        setIsEditNameModalVisible(true);
    };

    return (
        <>
            {/* Admin Header - only visible to Admin, Modellista, and ModellerSupervisor */}
            {isAdminAccess && (
                <div style={{
                    width: '100%',
                    height: 'auto',
                    backgroundColor: '#f0f2f5',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '15px 20px',
                    marginBottom: '10px',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                }}>
                    {/* Prima riga - ADMIN CONTROL PANEL */}
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                        <h2 style={{ margin: 0, color: '#333' }}>Admin Control Panel</h2>
                    </div>

                    {/* Divider */}
                    <div style={{
                        height: '1px',
                        backgroundColor: '#d9d9d9',
                        width: '100%',
                        margin: '0 0 15px 0'
                    }}></div>

                    {/* Seconda riga - Layout dinamico basato sul ruolo */}
                    <div style={{
                        display: 'flex',
                        flexDirection: windowWidth > 1200 ? 'row' : 'column',
                        justifyContent: windowWidth > 1200 ? 'space-between' : 'flex-start',
                        gap: windowWidth > 1200 ? '0px' : '12px',
                        width: '100%'
                    }}>
                        {/* Prima colonna/riga - Assign to (solo per Admin e ModellerSupervisor) */}
                        {canAssignVariants && (
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: windowWidth > 1200 ? (canAssignVariants ? '25%' : '0%') : '100%'
                            }}>
                                <Button
                                    type="primary"
                                    icon={<UserAddOutlined style={{ fontSize: '12px' }} />}
                                    style={{
                                        borderRadius: '6px',
                                        fontWeight: '500',
                                        background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                                        borderColor: '#8e44ad',
                                        color: 'white',
                                        boxShadow: '0 2px 0 rgba(0, 0, 0, 0.045)',
                                        height: '28px',
                                        padding: '0 10px',
                                        fontSize: '12px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        transition: 'all 0.3s ease'
                                    }}
                                    onClick={() => setIsAssignedModalVisible(true)}
                                >
                                    {allVariantsAssigned ? "Change Assignee" : "Assign to"}
                                </Button>
                            </div>
                        )}

                        {/* Seconda colonna/riga - Positioning Coefficients (visible for all roles) */}
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            width: windowWidth > 1200 ? (canAssignVariants ? '25%' : '50%') : '100%',
                            justifyContent: windowWidth > 1200 ? (canAssignVariants ? 'flex-start' : 'flex-start') : 'flex-start'
                        }}>
                            <Button
                                type="primary"
                                style={{
                                    ...buttonStyles.accent,
                                    borderRadius: '0.4rem',
                                    fontWeight: '500',
                                    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.12)',
                                    height: '28px',
                                    padding: '0 10px',
                                    fontSize: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px'
                                }}
                                onClick={() => setIsPositioningModalVisible(true)}
                                icon={<InfoCircleOutlined />}
                            >
                                Positioning Coefficients
                            </Button>
                        </div>

                        {/* Terza colonna/riga - 5 bottoni (per Admin e ModellerSupervisor) */}
                        {(role === 'Admin' || role === 'ModellerSupervisor') && (
                            <div style={{
                                display: 'flex',
                                gap: '6px',
                                alignItems: 'center',
                                width: windowWidth > 1200 ? '50%' : '100%',
                                justifyContent: windowWidth > 1200 ? 'flex-end' : 'flex-start',
                                flexWrap: 'wrap'
                            }}>
                                <Button
                                    type="primary"
                                    onClick={handleOpenAddTagModal}
                                    icon={<PlusOutlined />}
                                    style={{
                                        ...buttonStyles.primary,
                                        borderRadius: '0.4rem',
                                        fontWeight: '500',
                                        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.12)',
                                        height: '28px',
                                        padding: '0 8px',
                                        fontSize: '11px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px'
                                    }}
                                >
                                    Add New Tag
                                </Button>
                                <Button
                                    type="primary"
                                    onClick={handleOpenCreateTagModal}
                                    icon={<TagOutlined />}
                                    style={{
                                        ...buttonStyles.primary,
                                        borderRadius: '0.4rem',
                                        fontWeight: '500',
                                        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.12)',
                                        height: '28px',
                                        padding: '0 8px',
                                        fontSize: '11px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px'
                                    }}
                                >
                                    Create New Tag
                                </Button>
                                <Button
                                    type="primary"
                                    onClick={handleOpenAddBadgeModal}
                                    icon={<PlusOutlined />}
                                    style={{
                                        ...buttonStyles.primary,
                                        borderRadius: '0.4rem',
                                        fontWeight: '500',
                                        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.12)',
                                        height: '28px',
                                        padding: '0 8px',
                                        fontSize: '11px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px'
                                    }}
                                >
                                    Add New Badge
                                </Button>
                                <Button
                                    type="primary"
                                    onClick={handleOpenCreateBadgeModal}
                                    icon={<TagOutlined />}
                                    style={{
                                        ...buttonStyles.primary,
                                        borderRadius: '0.4rem',
                                        fontWeight: '500',
                                        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.12)',
                                        height: '28px',
                                        padding: '0 8px',
                                        fontSize: '11px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px'
                                    }}
                                >
                                    Create New Badge
                                </Button>
                                <Button
                                    type="primary"
                                    onClick={handleOpenAddLineModal}
                                    icon={<PlusOutlined />}
                                    style={{
                                        ...buttonStyles.primary,
                                        borderRadius: '0.4rem',
                                        fontWeight: '500',
                                        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.12)',
                                        height: '28px',
                                        padding: '0 8px',
                                        fontSize: '11px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px'
                                    }}
                                >
                                    Add New Line
                                </Button>
                            </div>
                        )}
                    </div>
                </div>
            )}
            <Space
                direction="vertical"
                size="large"
                style={{ width: '100%', padding: 'clamp(1rem, 0.8rem + 1vw, 1.25rem)', rowGap: '0px' }}
            >

                {/* Button back, title and EDIT Product Name (modificabile solo Admin) */}
                <HeaderComponent
                    buttonIcon={<NavigateBeforeIcon style={{ fontSize: '1.5rem' }} />}
                    buttonText=""
                    onButtonClick={() => navigate(-1)}
                    isVisible={true}
                    buttonPosition="left"
                    noCamp={true}
                    title={
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            {`Variant ${productData.modelName} Details`}
                            {role === 'Admin' && (
                                <EditOutlined
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        openEditNameModal();
                                    }}
                                    style={{
                                        marginLeft: '8px',
                                        cursor: 'pointer',
                                        fontSize: '16px',
                                        color: '#1890ff'
                                    }}
                                />
                            )}
                        </div>
                    }
                    rightContent={null}
                />

                {/* Contenitore principale: tutto su un'unica riga */}
                <div style={{
                    display: 'flex',
                    alignItems: 'stretch',
                    justifyContent: 'space-between',
                    gap: '20px',
                    width: '100%',
                    padding: '20px',
                    borderRadius: '12px',
                    minHeight: '500px'
                }}>
                    {/* Immagine del prodotto e Qr code */}
                    {productImage && (
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '20px',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                            width: '20%',
                            height: '100%',
                            alignSelf: 'center'
                        }}>
                            <div style={{
                                width: '150px',
                                height: '150px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '12px',
                                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                                padding: '10px',
                                backgroundColor: '#fff'
                            }}>
                                <img src={productImage} alt="Product" style={{ maxWidth: '100%', maxHeight: '100%' }} />
                            </div>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    marginTop: 'clamp(0.25rem, 0.2rem + 0.25vw, 0.375rem)'
                                }}
                            >
                            </div>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <div style={{
                                    height: '150px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '150px',
                                }}>
                                    {urlShadow && (
                                        <QRCodeWithHover value={urlShadow} id={productId} />
                                    )}
                                </div>
                                <Title level={5} style={{ marginTop: '8px', color: 'black' }}>QR Code</Title>
                            </div>
                        </div>
                    )}

                    {/* Taxonomies & Badges e Product Descriptions */}
                    <div style={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: '100%',
                        width: '100%'
                    }}>
                        <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '6px',
                            padding: '6px 8px',
                            borderRadius: '6px',
                            minHeight: '40px',
                            width: '100%'
                        }}>
                            {categories.length > 0 ? (
                                categories.map(category => (
                                    <Tag
                                        key={category.id}
                                        style={{
                                            margin: 0,
                                            backgroundColor: '#929acc',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '2px',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            textAlign: 'center'
                                        }}
                                        closable={role === 'Admin'}
                                        onClose={() => handleDeleteCategory(category.id)}
                                    >
                                        {category.name}
                                    </Tag>
                                ))
                            ) : (
                                <div style={{ color: '#999', padding: '4px' }}>No badges available</div>
                            )}
                        </div>
                        {/* Tabella Product Descriptions */}
                        <EditProduct product={productData} />
                    </div>
                </div>

                {/* Tabella delle Varianti sotto */}
                <div style={{ width: '100%', padding: '20px' }}>
                    <Title level={4}>Variants</Title>
                    <Table
                        columns={columns}
                        dataSource={variants}
                        rowKey="id"
                        pagination={false}
                        loading={loading}
                        showSorterTooltip={false}
                        bordered
                        size="small"
                        scroll={{ x: "max-content" }}
                        style={{ width: '100%' }}  /* Added to ensure the table takes full width */
                    />
                </div>


                {/* Richiamo di tutte le modali utilizzate nel componente */}
                <AddNewTag
                    isVisible={isAddModalVisible}
                    onClose={handleAddTagModalClose}
                    productId={productId}
                    productData={productData}
                    categories={categories}
                />

                <CreateNewTag
                    isVisible={isCreateTagModalVisible}
                    onClose={handleCreateTagModalClose}
                    productId={productId}
                    productData={productData}
                />

                <AddNewBadge
                    isVisible={isAddBadgeModalVisible}
                    onClose={handleAddBadgeModalClose}
                    productId={productId}
                    productData={productData}
                />

                <CreateNewBadge
                    isVisible={isCreateBadgeModalVisible}
                    onClose={handleCreateBadgeModalClose}
                    productId={productId}
                    productData={productData}
                />

                <AddNewLine
                    isVisible={isAddLineModalVisible}
                    onClose={handleAddLineModalClose}
                    productId={productId}
                    productData={productData}
                    categories={categories}
                />

                <VariantsAssignedToModal
                    isVisible={isAssignedModalVisible}
                    onCancel={() => setIsAssignedModalVisible(false)}
                    onSuccess={(updatedVariants) => {
                        // Aggiorna lo stato delle varianti nella pagina principale
                        if (updatedVariants) {
                            setVariants(prevVariants => {
                                const updatedVariantsMap = {};
                                updatedVariants.forEach(variant => {
                                    updatedVariantsMap[variant.id] = variant;
                                });

                                return prevVariants.map(variant =>
                                    updatedVariantsMap[variant.id] ? updatedVariantsMap[variant.id] : variant
                                );
                            });
                        }
                        setIsAssignedModalVisible(false);
                    }}
                    variants={variants}
                />

                <MediumModal
                    title="Positioning Coefficients"
                    visible={isPositioningModalVisible}
                    onClose={() => setIsPositioningModalVisible(false)}
                    hideFooter={true}
                >

                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        position: 'relative',
                        padding: '20px',
                    }}>
                        <Table
                            columns={[
                                { title: '', dataIndex: 'platform', key: 'platform' },
                                {
                                    title: (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <span>X</span>
                                            <CustomTooltip title="X-axis coefficient">
                                                <InfoCircleOutlined style={{ marginLeft: '8px', cursor: 'pointer' }} />
                                            </CustomTooltip>
                                        </div>
                                    ),
                                    dataIndex: 'x',
                                    key: 'x',
                                    render: (text, record) => (
                                        <InputNumber
                                            min={0}
                                            value={canModifyCoefficients(role) ? text : ''}
                                            onChange={(value) => handleCoefficientChange(record.key, 'x', value)}
                                            disabled={!canModifyCoefficients(role)}
                                        />
                                    )
                                },
                                {
                                    title: (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <span>Y</span>
                                            <CustomTooltip title="Y-axis coefficient">
                                                <InfoCircleOutlined style={{ marginLeft: '8px', cursor: 'pointer' }} />
                                            </CustomTooltip>
                                        </div>
                                    ),
                                    dataIndex: 'y',
                                    key: 'y',
                                    render: (text, record) => (
                                        <InputNumber
                                            min={0}
                                            value={canModifyCoefficients(role) ? text : ''}
                                            onChange={(value) => handleCoefficientChange(record.key, 'y', value)}
                                            disabled={!canModifyCoefficients(role)}
                                        />
                                    )
                                },
                                {
                                    title: (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <span>Z</span>
                                            <CustomTooltip title="Z-axis coefficient">
                                                <InfoCircleOutlined style={{ marginLeft: '8px', cursor: 'pointer' }} />
                                            </CustomTooltip>
                                        </div>
                                    ),
                                    dataIndex: 'z',
                                    key: 'z',
                                    render: (text, record) => (
                                        <InputNumber
                                            min={0}
                                            value={canModifyCoefficients(role) ? text : ''}
                                            onChange={(value) => handleCoefficientChange(record.key, 'z', value)}
                                            disabled={!canModifyCoefficients(role)}
                                        />
                                    )
                                }
                            ]}
                            dataSource={[
                                {
                                    key: 'ios',
                                    platform: 'iOS',
                                    x: canModifyCoefficients(role) ? positioningCoefficients.glassesInclinationCoeffIos || 'N/A' : '',
                                    y: canModifyCoefficients(role) ? positioningCoefficients.glassesYCoeff || 'N/A' : '',
                                    z: canModifyCoefficients(role) ? positioningCoefficients.glassesZCoeff || 'N/A' : ''
                                },
                                {
                                    key: 'android',
                                    platform: 'Android',
                                    x: canModifyCoefficients(role) ? positioningCoefficients.glassesInclinationCoeff || 'N/A' : '',
                                    y: canModifyCoefficients(role) ? positioningCoefficients.glassesYCoeffAndroid || 'N/A' : '',
                                    z: canModifyCoefficients(role) ? positioningCoefficients.glassesZCoeffAndroid || 'N/A' : ''
                                }
                            ]}
                            rowKey="platform"
                            pagination={false}
                            bordered
                            size="small"
                            style={{
                                filter: !canModifyCoefficients(role) ? 'blur(5px)' : 'none',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center'
                            }}
                        />
                        {!canModifyCoefficients(role) && (
                            <div style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                zIndex: 1,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                color: '#000',
                                fontSize: '16px',
                                fontWeight: 'bold'
                            }}>
                                You do not have permission to view this data
                            </div>
                        )}
                    </div>
                </MediumModal>

                <SmallModal
                    title="Edit Product Name"
                    visible={isEditNameModalVisible}
                    onClose={() => setIsEditNameModalVisible(false)}
                    onConfirm={handleEditProductName}
                    cancelText="Cancel"
                    confirmText="Save"
                >
                    <Input
                        value={newProductName}
                        onChange={(e) => setNewProductName(e.target.value)}
                        placeholder="Enter new product name"
                    />
                </SmallModal>
                {/* Fine richiamo modali */}

            </Space>
        </>
    );
}

export default Variants;